import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} Colors
 */

const URL = 'colors-list';
const URL_UPDATE = 'colors/favorite/';
const URL_FILTERS = 'colors-filters/';
const URL_ALL_COLORS = 'colors/';
const URL_FAVORITES = 'colors/favorite/';
const URL_COLORS_BATCHNUMBER = 'colors-with-batchno/';

const fetchColors = async (filterParams: string) => {
  return client.get(URL + filterParams);
};

const fetchAllColors = async () => {
  return client.get(URL_ALL_COLORS);
};

const fetchFavoriteColors = async () => {
  return client.get(URL_FAVORITES);
};


const fetchAnotherPage = async (url: string) => {
  return client.get(url);
};

const fetchFilters = async () => {
  return client.get(URL_FILTERS);
};

const fetchColorsWithBatchNumber = async (colorsId: Array<Number>) => {
  const requestBody = {color_ids: colorsId};
  const res = await client.post(URL_COLORS_BATCHNUMBER, requestBody);
  return res.data;
};

const updateFavoriteColors = async (id: number) => {
  return client.post(URL_UPDATE + id + '/');
};

const actions = {
  fetchColors,
  fetchAllColors,
  fetchFavoriteColors,
  fetchFilters,
  fetchAnotherPage,
  fetchColorsWithBatchNumber,
  updateFavoriteColors,
};

export default actions;
